
import React from 'react';

export default function RIQLoading() {
    return (
        <div className='tlw-grid tlw-h-[100px] tlw-place-items-center '>
            <div className='tlw-text-[36px] tlw-text-gray-500'>
                <span className='fa fa-circle-o-notch fa-spin'></span>
            </div>
        </div>
    );
}
